import { render, staticRenderFns } from "./LiquorLicense.vue?vue&type=template&id=0e78f133"
import script from "./LiquorLicense.vue?vue&type=script&lang=ts"
export * from "./LiquorLicense.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports